import { bindActionCreators } from 'redux';

import { initializeActions as initializeCommonActions } from '../../common/controller/init-actions';
import { initialiseInstanceValues } from '../../common/store/instance-values/instance-values-actions';
import { getInstanceId } from '../../common/store/instance-values/instance-values-selectors';
import { fetchTopology } from '../../common/store/topology/topology-actions';
import { setLocale, setQueryLocaleAction } from '../../common/store/locale/locale-actions';
import { setAppSettings } from '../../common/store/app-settings/app-settings-actions';
import { setBasicParams } from '../../common/store/basic-params/basic-params-actions';
import { setAppConfig } from '../../common/store/app-config/app-config-actions';
import { getInstance } from '../../common/controller/helpers';
import { fetchArchiveWidgetInitialData } from '../actions/fetch-initial-data';
import { getIsICUBaseUrlEnabled } from '../../common/selectors/icu-selectors';

export { initializePromisifiedActions, refreshDataOnLogin } from '../../common/controller/init-actions';

export function initializeActions({ wixCodeApi, store, fedopsLogger, appParams }) {
  return {
    ...initializeCommonActions({ wixCodeApi, store, fedopsLogger }),
    ...bindActionCreators(
      {
        fetchArchiveWidgetInitialData: () => fetchArchiveWidgetInitialData({ useICU: getIsICUBaseUrlEnabled(appParams) }),
      },
      store.dispatch,
    ),
  };
}

export async function initializeStoreBaseData({
  wixCodeApi,
  store,
  language,
  platformAPIs,
  config,
  bundleName,
  appParams,
}) {
  const viewMode = wixCodeApi.window.viewMode.toLowerCase();

  store.dispatch(initialiseInstanceValues(getInstance(wixCodeApi)()));

  const instanceId = getInstanceId(store.getState());
  store.dispatch(setLocale(language));
  store.dispatch(setQueryLocaleAction(wixCodeApi, appParams));
  const useICU = getIsICUBaseUrlEnabled(appParams);

  await Promise.all([
    store.dispatch(setAppSettings({ style: config.style.styleParams })),
    store.dispatch(setBasicParams({ viewMode, language, biPageNumber: platformAPIs.bi.pageNumber })),
    store.dispatch(setAppConfig({ bundleName })),
    store.dispatch(fetchArchiveWidgetInitialData({ useICU })),
  ]);
  await store.dispatch(fetchTopology(instanceId));
}
